import { render, staticRenderFns } from "./extra-benefits-list.vue?vue&type=template&id=124fac74&scoped=true&"
import script from "./extra-benefits-list.vue?vue&type=script&lang=js&"
export * from "./extra-benefits-list.vue?vue&type=script&lang=js&"
import style0 from "./extra-benefits-list.vue?vue&type=style&index=0&id=124fac74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fac74",
  null
  
)

export default component.exports